module.exports = __webpack_public_path__ + "static/media/external_env_4_media_4.0036bbb3.webp";